import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 bg-white px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-8 leading-tight" data-id="element-4">
            Si hoy vuelves a despertar a las 3am, puedes hacer lo de siempre.
          </h2>

          <p className="text-xl md:text-2xl text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-5">
            Pensar, preocuparte, pelearte con tu mente.
            <br data-id="element-6" />
            <span className="font-bold text-[#0d9488] block mt-4" data-id="element-7">
              O puedes tener un plan.
            </span>
          </p>

          <div className="bg-[#fef3e2] p-8 md:p-12 rounded-3xl max-w-2xl mx-auto shadow-lg border border-[#fef3e2]" data-id="element-8">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-9">
              Descarga "Hormonas en Calma (45+)"
            </h3>
            <p className="text-slate-600 mb-8" data-id="element-10">Empieza hoy con el Día 1</p>

            <div className="flex items-baseline justify-center gap-2 mb-8" data-id="element-11">
              <span className="text-5xl font-bold text-[#0d9488]" data-id="element-12">$6.39</span>
              <span className="text-xl text-slate-400 line-through" data-id="element-13">$29</span>
              <span className="text-sm font-semibold bg-[#0d9488]/10 text-[#0d9488] px-2 py-1 rounded ml-2" data-id="element-14">
                78% OFF
              </span>
            </div>

            <a href="https://prodigitalideas.com/cart/51088017195306:1" className="inline-flex w-full md:w-auto bg-[#0d9488] hover:bg-[#0f766e] text-white text-xl font-bold py-5 px-10 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105 items-center justify-center gap-3" data-id="element-15">
              Quiero mi Plan Anti-3am
              <ArrowRight className="w-6 h-6" data-id="element-16" />
            </a>

            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-17">
              <ShieldCheck className="w-4 h-4" data-id="element-18" />
              <span data-id="element-19">Pago seguro • Descarga inmediata</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}